module.exports = __webpack_public_path__ + "static/img/14000591.700f5194.png";